var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import { Money } from "@upserve/financials";
import { reduce } from "ramda";
import PaymentPage from "components/mobile_pay/views/payment_page";
import { getCheckTotal } from "helpers/mobile_pay";
import { RequestStatus } from "types/requests";
import CheckPaidPage from "components/mobile_pay/views/check_paid_page";
import PaymentSuccessPage from "components/mobile_pay/views/payment_success_page";
var StyledMobilePayWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #ededed;\n  max-width: 1024px;\n  height: 100vh;\n  margin: 0 auto;\n  padding: 24px 12px;\n"], ["\n  background-color: #ededed;\n  max-width: 1024px;\n  height: 100vh;\n  margin: 0 auto;\n  padding: 24px 12px;\n"])));
function isCheckPaid(checkInfo) {
    // check the QR code balance due
    if (checkInfo.balanceDue.lte(Money(0))) {
        return true;
    }
    // check any payments retunred by the backend
    var paymentTotal = reduce(function (acc, payment) {
        return acc.add(payment.amount);
    }, Money(0), checkInfo.payments);
    var checkTotal = getCheckTotal(checkInfo);
    return checkTotal.lte(paymentTotal);
}
export default function ViewStateManager(props) {
    var merchantInfo = props.merchantInfo, checkInfo = props.checkInfo, processedPaymentInfoRequest = props.processedPaymentInfoRequest;
    document.title = merchantInfo.name;
    var content;
    if (processedPaymentInfoRequest.type === RequestStatus.SUCCESS) {
        content = (React.createElement(PaymentSuccessPage, { merchantInfo: merchantInfo, checkInfo: checkInfo, processedPaymentInfo: processedPaymentInfoRequest.result }));
    }
    else if (isCheckPaid(checkInfo)) {
        content = (React.createElement(CheckPaidPage, { merchantInfo: merchantInfo, checkInfo: checkInfo }));
    }
    else {
        content = React.createElement(PaymentPage, __assign({}, props));
    }
    return React.createElement(StyledMobilePayWrapper, null, content);
}
var templateObject_1;
